import { PageHeader } from '@/components/PageHeader/PageHeader.tsx'
import { Box, Stack, Tab, Tabs } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useCompany } from '@/contexts/CompaniesContext.tsx'
import { AlertList } from '@/features/notifications/components/AlertList.tsx'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
import React, { type SyntheticEvent, useState } from 'react'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

export const Route = createFileRoute('/_authenticated/$companySlug/notification-center')({
  beforeLoad: ({ context }) => {
    context.auth.rejectIfMissingPermissions(['NOTIFICATION_READ'])
  },
  component: NotificationManager,
  head: () => ({
    meta: [{ title: i18n.t('_routes:routes.notification-center.main.title') }]
  })
})

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`user-list-tabpanel-${index}`}
      aria-labelledby={`user-list-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  )
}

function a11yProps(index: number) {
  return {
    id: `notification-center-tab-${index}`,
    'aria-controls': `notification-center-tabpanel-${index}`
  }
}

function NotificationManager() {
  const { t } = useTranslation(['_routes', '_global'])
  const { sites } = useCompany()
  const { sites: filterSites } = Route.useSearch()

  const [tabValue, setTabValue] = useState(0)
  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Stack spacing={4}>
      <PageHeader
        subtitle={t('_routes:routes.notification-center.main.subtitle')}
        backArrow={{ historyBack: true }}
      >
        {t('_routes:routes.notification-center.main.title')}
      </PageHeader>

      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="notification-center-tabs"
      >
        <Tab
          iconPosition="start"
          icon={<WarningAmberOutlinedIcon sx={{ mr: 1 }} />}
          label={t('routes.notification-center.main.tabs.alerts')}
          {...a11yProps(0)}
        />
      </Tabs>

      <CustomTabPanel value={tabValue} index={0}>
        <AlertList sites={sites} selectedSiteIds={filterSites} />
      </CustomTabPanel>
    </Stack>
  )
}
